<article class="page-container flex flex-column">
  <section class="align-self-end py-2">
    <span class="inline-flex align-items-center">
      <label class="no-margin" for="showExpandable"
        [style.margin-right.px]="10">{{screen.actions.showExpandable}}</label>
      <p-inputSwitch name="showExpandable" [(ngModel)]="showExpandable" validation>
      </p-inputSwitch>
    </span>

    <p-button type="button" icon="fas fa-file-upload" [label]="screen.actions.uploadFile"
      styleClass="p-button-success p-button-outlined ml-2" (onClick)="showUploadDialog = true" *ngIf="isAdmin">
    </p-button>
  </section>

  <section class="inline-flex py-2" ms-common-atc-exp-table (atcTable)="atcTable = $event" [isDoctor]="isDoctor"
    [isCounter]="isCounter" *ngIf="showExpandable">
  </section>

  <section class="inline-flex py-2" ms-common-atc-table (atcTable)="atcTable = $event" [isDoctor]="isDoctor"
    [isCounter]="isCounter" *ngIf="!showExpandable">
  </section>
</article>

<ms-common-atc-upload-model [(showDialog)]="showUploadDialog" (onSuccess)="handleUploadSuccess()"
  *ngIf="showUploadDialog">
</ms-common-atc-upload-model>